import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Styles a decoration-matched URL green like a link. Display only — the underlying text is unchanged.
export function StyledUrlHighlight({ attributes, children, className }) {
  return (
    <StyledUrl {...attributes} className={className} data-aid="urlHighlight">
      {children}
    </StyledUrl>
  );
}

const StyledUrl = styled.span`
  color: ${p => p.theme.colors.green400};
`;

StyledUrlHighlight.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};
